import { render, staticRenderFns } from "./photoScan.vue?vue&type=template&id=dc577d92&scoped=true"
import script from "./photoScan.vue?vue&type=script&lang=js"
export * from "./photoScan.vue?vue&type=script&lang=js"
import style0 from "./photoScan.vue?vue&type=style&index=0&id=dc577d92&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc577d92",
  null
  
)

export default component.exports